import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

import styles from './TabPanel.css';


function TabPanel(props) {
  const { children, value, index, scrollToBottom, ...other } = props;
  const containerRef = useRef(null);
  useEffect(() => {
    if (scrollToBottom && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight - containerRef.current.clientHeight;
    }
  }, [scrollToBottom]);

  return (
    <div
      ref={containerRef}
      aria-labelledby={`chat-tabs-${index}`}
      hidden={value !== index}
      id={`chat-tabsPanel-${index}`}
      role="tabpanel"
      {...other}
      className={styles.TabPanel}
    >
      {value === index && (
        <Box className={styles.Box} p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.defaultProps = {
  children: {},
  scrollToBottom: false,
};

TabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.node,
  scrollToBottom: PropTypes.bool,
};

export default TabPanel;
